/**
 * vehicles.repository — 차량 CRUD.
 *
 * doc id = 차량번호(plate). 중복 등록 방지.
 */
import {
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  serverTimestamp,
  setDoc,
  type Unsubscribe,
} from "firebase/firestore";
import { auth, db } from "./firebase";
import { tcol } from "@/domain/tenantPath";
import { coerceVehicle, type Vehicle, type VehicleCategory } from "@/domain/vehicle";

const COL = "vehicles";

export interface VehicleInput {
  plate: string;
  category: VehicleCategory;
  driver_name: string;
  registered_at: string;
  active: boolean;
}

export const vehiclesRepo = {
  subscribeAll(
    cb: (rows: Vehicle[]) => void,
    onError?: (err: Error) => void,
  ): Unsubscribe {
    return onSnapshot(
      collection(db, tcol(COL)),
      (snap) => cb(snap.docs.map((d) => coerceVehicle(d.id, d.data()))),
      (err) => onError?.(err),
    );
  },

  async upsert(input: VehicleInput): Promise<void> {
    const user = auth.currentUser;
    await setDoc(
      doc(db, tcol(COL), input.plate),
      {
        plate: input.plate,
        category: input.category,
        driver_name: input.driver_name,
        registered_at: input.registered_at,
        active: input.active,
        edited_at: serverTimestamp(),
        edited_by: user?.uid ?? null,
      },
      { merge: true },
    );
  },

  async remove(plate: string): Promise<void> {
    await deleteDoc(doc(db, tcol(COL), plate));
  },
};
